import React, { Component, Suspense } from 'react';
import './App.scss';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';

class RouterWrapperApp extends Component {
    render() {
        return (
            <Router>
                <App />
            </Router>
      );
    }

}

export default RouterWrapperApp;
